import BaseModel from '@/app-core/lib/data/model/BaseModel'
import AccountSettingsValidator from '@/app-core/api/validations/account/AccountSettingsValidator'
import AccountSettingsResource from '@/app-core/api/resources/account/AccountSettingsResource'
import API from '@/app-core/api/Api'
import DataEventEnum from '@/app-core/lib/services/enum/DataEventEnum'
import DataEventService from '@/app-core/lib/services/event/DataEventService'
import CustomerModel from '@/app-core/api/models/customer/CustomerModel'

export default class AccountSettingsModel extends BaseModel {
  constructor(payload = {}, resource = AccountSettingsResource, validator = AccountSettingsValidator) {
    super(payload, resource, validator)
  }

  boot() {
    super.boot()

    this.guarded = ['Email', 'PhoneOriginal', 'PhoneOriginalPrefix']
  }

  /* PROPERTIES */

  /* METHODS */
  async SaveSettings(autosave = false) {
    const payload = {Info: this.clone()}
    payload.Info.AutoSave = autosave

    DataEventService.Emit(DataEventEnum.EVENT, {
      Event  : DataEventEnum.ACCOUNT_UPDATE,
      Payload: this.clone()
    })

    const result = await API.Resource.Account.Details(payload)
    const data = API.responseData(result)
    if (API.isResponseSuccess(result) && data?.Messages?.Success && data?.CustomerInfo) {
      window.Vue.user = new CustomerModel(data.CustomerInfo)
    }

    return result
  }

  async DeleteAccount(payload) {
    DataEventService.Emit(DataEventEnum.EVENT, {
      Event  : DataEventEnum.ACCOUNT_DELETE,
      Payload: this.clone()
    })

    return await API.Resource.Account.Delete(payload)
  }

  async ExportAccount(payload) {
    DataEventService.Emit(DataEventEnum.EVENT, {
      Event  : DataEventEnum.ACCOUNT_EXPORT,
      Payload: this.clone()
    })

    return await API.Resource.Account.Export(payload)
  }

  async ConfirmPin(payload) {
    return await API.Resource.Account.Pin(payload)
  }
}
